import { createAction, props } from "@ngrx/store";
import { IPacchiInGiacenzaResponse } from "../../interfaces/response-pacchi-giacenza";
import { ICollectPointPayload, IMovimentazioneListPayload, IMovimentazioneListResponse } from "../../interfaces/movimentazione-list";
import { IMovimentazioneMailResponse } from "../../interfaces/movimentazione-mail";
import { IVerificaMagazzinoPacchi } from "../../interfaces/response-verifica-magazzino-pacchi";
import { IBeniContoDeposito } from "../../interfaces/beni-conto-deposito";
import { IPayloadScatolaNonDisponibile, IResponseScatolaNonDisponibile } from "../../interfaces/scatola-non-disponibile";
import { IResponseChangeStatusVerifica, IPayloadChangeStatusVerifica } from "../../interfaces/change-status-verifica";
import { IResponseExistsScatolaFlyer } from "../../interfaces/exists-scatola-flyer";
import { IPayloadChiudiScatola, IResponseChiudiScatola } from "../../interfaces/chiudi-scatola";
import { IPayloadChiusuraScatoleBxl, IResponseChiusuraScatoleBxl } from "../../interfaces/chiusura-scatole-bxl";
import { IPayloadStoricoAnnualeContoDeposito, IPayloadStoricoOggettoContoDeposito, IResponseStoricoOggettoContoDeposito } from "../../interfaces/storico-oggetto-conto-deposito";
import { IPayloadMovimentazioneCreateEvent, IResponseMovimentazioneCreateEvent } from "../../interfaces/movimentazione-create-event";


export const PACCHI_IN_GIACENZA = createAction(
  '[PACKAGE-WAREHOUSE] - retrieve pacchi in giacenza'
);

export const PACCHI_IN_GIACENZA_SUCCESS = createAction(
  '[PACKAGE-WAREHOUSE] - retrieve pacchi in giacenza success',
  props<{ responsePacchiInGiacenza: IPacchiInGiacenzaResponse | null }>()
);

export const MOVIMENTAZIONE_LIST = createAction(
  '[PACKAGE-WAREHOUSE] - retrieve movimentazione list',
  props<{ payload: IMovimentazioneListPayload }>()
);

export const MOVIMENTAZIONE_LIST_SUCCESS = createAction(
  '[PACKAGE-WAREHOUSE] - retrieve movimentazione list success',
  props<{ responseMovimentazione: IMovimentazioneListResponse | null }>()
);

export const ESPORTA_FILE_XLS = createAction(
  '[PACKAGE-WAREHOUSE] - retrieve esporta file xls',
  props<{ payload: IMovimentazioneListPayload }>()
);

export const ESPORTA_FILE_XLS_SUCCESS = createAction(
  '[PACKAGE-WAREHOUSE] - retrieve esporta file xls success',
  props<{ responseEsportaXls: string | null }>()
);

export const ESPORTA_FILE_MAIL = createAction(
  '[PACKAGE-WAREHOUSE] - retrieve esporta file mail',
  props<{ payload: ICollectPointPayload }>()
);

export const ESPORTA_FILE_MAIL_SUCCESS = createAction(
  '[PACKAGE-WAREHOUSE] - retrieve esporta file mail success',
  props<{ responseEsportaMail: IMovimentazioneMailResponse | null }>()
);

export const RETRIVE_BOX_TO_CHECK =createAction(
  '[PACKAGE-WAREHOUSE] - retrive box to check'
)

export const RETRIVE_BOX_TO_CHECK_SUCCESS =createAction(
  '[PACKAGE-WAREHOUSE] - retrive box to check success',
  props<{responseVerificaBox: IVerificaMagazzinoPacchi | null}>()
)

export const BENI_CONTO_DEPOSITO = createAction(
  '[PACKAGE-WAREHOUSE] - retrieve beni conto deposito'
);

export const BENI_CONTO_DEPOSITO_SUCCESS = createAction(
  '[PACKAGE-WAREHOUSE] - retrieve beni conto deposito success',
  props<{ responseBeniContoDeposito: IBeniContoDeposito | null }>()
);

export const SCATOLA_NON_DISPONIBILE = createAction(
  '[PACKAGE-WAREHOUSE] - retrieve scatola non disponibile',
  props<{ payload: IPayloadScatolaNonDisponibile }>()
);

export const SCATOLA_NON_DISPONIBILE_SUCCESS = createAction(
  '[PACKAGE-WAREHOUSE] - retrieve scatola non disponibile success',
  props<{ responseScatolaNonDisponibile: IResponseScatolaNonDisponibile | null }>()
);

export const CHANGE_STATUS_VERIFICA = createAction(
  '[PACKAGE-WAREHOUSE] - retrieve change status verifica',
  props<{ payload: IPayloadChangeStatusVerifica }>()
);

export const CHANGE_STATUS_VERIFICA_SUCCESS = createAction(
  '[PACKAGE-WAREHOUSE] - retrieve change status verifica success',
  props<{ responseChangeStatusVerifica: IResponseChangeStatusVerifica | null }>()
);

export const EXISTS_SCATOLA_FLYER = createAction(
  '[PACKAGE-WAREHOUSE] - retrieve exists scatola flyer',
  props<{ code: string }>()
);

export const EXISTS_SCATOLA_FLYER_SUCCESS = createAction(
  '[PACKAGE-WAREHOUSE] - retrieve exists scatola flyer success',
  props<{ responseExistsScatolaFlyer: IResponseExistsScatolaFlyer | null }>()
);

export const CHIUDI_SCATOLA = createAction(
  '[PACKAGE-WAREHOUSE] - retrieve chiudi scatola',
  props<{ payload: IPayloadChiudiScatola }>()
);

export const CHIUDI_SCATOLA_SUCCESS = createAction(
  '[PACKAGE-WAREHOUSE] - retrieve chiudi scatola success',
  props<{ responseChiudiScatola: IResponseChiudiScatola | null }>()
);

export const CHIUSURA_SCATOLE_BXL = createAction(
  '[PACKAGE-WAREHOUSE] - retrieve chiusura scatole bxl',
  props<{ payload: IPayloadChiusuraScatoleBxl }>()
);

export const CHIUSURA_SCATOLE_BXL_SUCCESS = createAction(
  '[PACKAGE-WAREHOUSE] - retrieve chiusura scatole bxl success',
  props<{ responseChiusuraScatoleBxl: IResponseChiusuraScatoleBxl | null }>()
);

export const STORICO_OGGETTO_CONTO_DEPOSITO = createAction(
  '[PACKAGE-WAREHOUSE] - retrieve storico oggetto conto deposito',
  props<{ payload: IPayloadStoricoOggettoContoDeposito }>()
);

export const STORICO_OGGETTO_CONTO_DEPOSITO_SUCCESS = createAction(
  '[PACKAGE-WAREHOUSE] - retrieve storico oggetto conto deposito success',
  props<{ responseStoricoContoDeposito: IResponseStoricoOggettoContoDeposito | null }>()
);

export const STORICO_ANNUALE_CONTO_DEPOSITO = createAction(
  '[PACKAGE-WAREHOUSE] - retrieve storico annuale conto deposito',
  props<{ payload: IPayloadStoricoAnnualeContoDeposito }>()
);

export const STORICO_ANNUALE_CONTO_DEPOSITO_SUCCESS = createAction(
  '[PACKAGE-WAREHOUSE] - retrieve storico annuale conto deposito success',
  props<{ responseStoricoAnnualeContoDeposito: any }>()
);

export const MOVIMENTAZIONE_CREATE_EVENT = createAction(
  '[PACKAGE-WAREHOUSE] - retrieve movimentazione create event',
  props<{ payload: IPayloadMovimentazioneCreateEvent }>()
);

export const MOVIMENTAZIONE_CREATE_EVENT_SUCCESS = createAction(
  '[PACKAGE-WAREHOUSE] - retrieve movimentazione create event success',
  props<{ responseMovimentazioneCreateEvent: IResponseMovimentazioneCreateEvent | null }>()
);

